import shuffle from 'lodash/shuffle';
import { TOP_STORES_GET_SUCCESS, TOP_STORES_GET_FAILURE } from '../actions/types';
import topStoresConfig from '../configs';

const initialState = {
  config: topStoresConfig,
  merchants: [],
  isLoading: false,
  isLoaded: false,
};

const topStores = (state = initialState, action) => {
  switch (action.type) {
    case TOP_STORES_GET_SUCCESS: {
      const placements = action.payload.response;
      const merchants = placements.map(placement => placement.merchant);
      return {
        ...state,
        merchants: shuffle(merchants),
        isLoading: false,
        isLoaded: true,
      };
    }
    case TOP_STORES_GET_FAILURE: {
      return {
        ...state,
        merchants: [],
        isLoading: false,
        isLoaded: true,
      }; // we'd have to decide what to do with error state
    }
    default: {
      const { options = {} } = action;
      // Handle setting isLoading to true for raw OCAPI action
      if (options.success === TOP_STORES_GET_SUCCESS) {
        return { ...state, isLoading: true };
      }

      return state;
    }
  }
};

export default topStores;
